import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

interface IAuth {
    status: boolean | undefined;
}

export function useAuth(): IAuth {
    const [status, setStatus] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const session = await fetchAuthSession();
                const token = session.tokens?.accessToken;

                if (token) {
                    setStatus(true);
                } else {
                    setStatus(false);
                }
            } catch {
                setStatus(false);
            }
        };

        checkAuth();
    }, []);

    return { status };
}